import type { NoteDeLaBoite } from '../api/types';
import { jourDUnInstant } from '../datesEnMots';

/**
 * Les mots de la boîte d'entrée (chantier boite-d-entree, ticket 02) : la page de l'ordinateur et
 * son entrée dans la barre de gauche. Ce qu'on note vite, sans chercher où le mettre, puis qu'on
 * range dans un projet ou une bulle.
 */
export const BOITE_D_ENTREE = 'Boîte d’entrée';
export const SOUS_TITRE_DE_LA_BOITE = 'Ce que tu notes vite, avant de le ranger.';
export const NOTER = 'Noter…';
export const NOTER_DANS_LA_BOITE = 'Noter dans la boîte';
/** Vide : à quoi sert la boîte. */
export const BOITE_VIDE =
  'Rien dans ta boîte. Note ici ce qui te passe par la tête, sans chercher où le mettre : tu le rangeras dans un projet quand tu auras le temps.';
export const RANGER_DANS = 'Ranger dans…';
export const RETIRER_LA_NOTE = 'Retirer la note';
export const CHERCHER_OU_RANGER = 'Un projet ou une bulle';
export const MES_PROJETS_POUR_RANGER = 'Tes projets, ou cherche une bulle par son nom';
export const RIEN_DE_CE_NOM = 'Rien de ce nom';
export const AUCUN_PROJET_OU_RANGER = 'Aucun projet encore : crée-en un pour y ranger tes notes.';
export const UN_PROJET = 'Un projet';
/** Petit, sous une note qui vient de Claude. */
export const PAR_CLAUDE = 'par Claude';

/** Sous la note : sa date courte (l'année si ce n'est pas celle-ci), et « par Claude » quand elle vient de lui. */
export function mentionDeLaNote(note: Pick<NoteDeLaBoite, 'origine' | 'creeLe'>, maintenant = new Date()): string {
  const jour = jourDUnInstant(note.creeLe, maintenant);
  return note.origine === 'claude' ? `${jour} · ${PAR_CLAUDE}` : jour;
}

/** Le compte de la barre de gauche, pour le lecteur d'écran et l'infobulle. */
export function notesDansLaBoite(n: number): string {
  return n === 1 ? '1 note dans la boîte' : `${n} notes dans la boîte`;
}

/** Ce qui s'est passé quand un geste de la boîte n'a pas eu lieu. */
export function boitePasEcrite(code: string): string {
  if (code === 'boite_pleine') return 'Ta boîte est pleine : range ou retire des notes avant d’en noter d’autres';
  if (code === 'note_introuvable') return 'Cette note n’est plus dans ta boîte';
  if (code === 'parent_introuvable') return 'Cette bulle n’existe plus : choisis-en une autre';
  if (code === 'hors_ligne') return 'Hors ligne : rien n’est écrit, réessaie quand le réseau revient';
  return 'La boîte n’a pas pu être écrite, réessaie';
}
